import { render, staticRenderFns } from "./lid-client-tourist.vue?vue&type=template&id=6a87d140&"
import script from "./lid-client-tourist.vue?vue&type=script&lang=js&"
export * from "./lid-client-tourist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports